/** The toast layer sits above Fun's checkout, so the transfer cards hide while any owner holds. */

import { useEffect, useId } from "react";
import { create } from "zustand";

interface TransferProgressVisibilityState {
  owners: ReadonlySet<string>;
  /** Idempotent per owner, so a repeated effect run cannot stack holds. */
  hold: (owner: string) => void;
  release: (owner: string) => void;
}

export const useTransferProgressVisibility = create<TransferProgressVisibilityState>((set) => ({
  owners: new Set(),
  hold: (owner) =>
    set((state) => {
      if (state.owners.has(owner)) return state;
      return { owners: new Set(state.owners).add(owner) };
    }),
  release: (owner) =>
    set((state) => {
      if (!state.owners.has(owner)) return state;
      const owners = new Set(state.owners);
      owners.delete(owner);
      return { owners };
    }),
}));

export function useHideTransferProgress() {
  const owner = useId();
  useEffect(() => {
    const { hold, release } = useTransferProgressVisibility.getState();
    hold(owner);
    return () => release(owner);
  }, [owner]);
}

export function useTransferProgressHidden() {
  return useTransferProgressVisibility((state) => state.owners.size > 0);
}
